import { render, staticRenderFns } from "./ResetPWD.vue?vue&type=template&id=32a8e928&scoped=true&lang=pug"
import script from "./ResetPWD.vue?vue&type=script&lang=js"
export * from "./ResetPWD.vue?vue&type=script&lang=js"
import style0 from "./ResetPWD.vue?vue&type=style&index=0&id=32a8e928&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8e928",
  null
  
)

export default component.exports